import { ActionIcon, Badge, Group } from "@mantine/core";
import { IconEye } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { Doc } from "../../DeliveryOverview/DeliveryOverview.types";
import type { GenerateAndDownloadPreviewParams } from "../hooks/usePreviewInvoices";
function getTypeColumn(
  onPreview: (params: GenerateAndDownloadPreviewParams) => void,
  loadingPreviews: Array<string>
): MRT_ColumnDef<Doc> {
  return {
    header: "Typ",
    accessorKey: "documentType",
    enableSorting: false,
    size: 190,
    enableColumnFilter: false,
    filterFn: (row, id, value) => {
      const docType = row.getValue(id);
      if (value === "all") {
        return true;
      } else {
        return docType === value;
      }
    },
    Cell: ({ row }) => {
      switch (row.original.documentType) {
        case "draft": {
          return (
            <Group wrap="nowrap">
              <Badge color="neutral" radius="sm" variant="outline">
                Vorschau
              </Badge>
              <ActionIcon
                aria-label="Vorschau herunterladen"
                color="#333"
                loading={loadingPreviews.includes(row.original.id)}
                variant="transparent"
              >
                <IconEye
                  onClick={() =>
                    row.original.pendingInvoice
                      ? onPreview({
                          pendingInvoice: row.original.pendingInvoice
                        })
                      : null
                  }
                />
              </ActionIcon>
            </Group>
          );
        }
        case "invoice": {
          let docType = "Rechnung";
          if (row.original.invoiceData?.isAdvanceInvoice) {
            docType = "Abschlagsrechnung";
          } else if (row.original.invoiceData?.isCorrectionInvoice) {
            docType = "Korrekturrechnung";
          }
          return (
            <Badge radius="sm" variant="outline">
              {docType}
            </Badge>
          );
        }
        case "reversed": {
          return (
            <Badge color="secondary" radius="sm" variant="outline">
              Storniert
            </Badge>
          );
        }
        case "reversal": {
          return (
            <Badge color="error" radius="sm" variant="outline">
              Stornobeleg
            </Badge>
          );
        }
        default: {
          return;
        }
      }
    }
  };
}

export { getTypeColumn };
